<template>
  <div class="card_item_container">
    <div class="card_container">
      <div class="card_left">
        <img :src="cardItemInfo.cover_img" style="border-radius: 10px" />
      </div>
      <div class="card_right">
        <div class="card_right_title">
          {{ cardItemInfo.title || "--" }}
        </div>
        <div class="card_right_subtitle">
          {{ cardItemInfo.sub_title || "--" }}
        </div>
      </div>
    </div>
    <div
      class="m_desc"
      style="margin-top: 5px"
      v-if="cardItemInfo.memo || cardItemInfo.sub_type_str">
      <div class="m_color_2" v-if="cardItemInfo.sub_type_str">
        【{{ cardItemInfo.sub_type_str }}】
      </div>
      <div v-if="cardItemInfo.memo">备注：{{ cardItemInfo.memo }}</div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    cardItem: {
      type: [Object, String],
      default: () => {
        return {};
      },
    },
  },
  setup(props) {
    const cover_img = "https://s-m.lm12301.com/img/wexincard.jpg";

    const cardItemInfo = computed(() => {
      if (typeof props.cardItem === "string") {
        try {
          return JSON.parse(props.cardItem);
        } catch (error) {
          return {};
        }
      }
      return props.cardItem || {};
    });

    return {
      cover_img,
      cardItemInfo,
    };
  },
};
</script>
<style lang="less" scoped></style>
